import * as React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";

/**
 * Dialog for adding or editing an order.
 */
export default function OrderDialog({
  open,
  onClose,
  editing = false,
  formData = {},
  onFormDataChange,
  onSave,
}) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>{editing ? "Edit Order" : "Add Order"}</DialogTitle>
      <DialogContent sx={{ pt: 2 }}>
        <Grid container spacing={1.5}>
          <Grid size={{ xs: 12, sm: 6 }}>
            <TextField
              fullWidth
              label="Order Number"
              value={formData.order_number || ""}
              onChange={(e) => onFormDataChange({ ...formData, order_number: e.target.value })}
              margin="dense"
              size="small"
              required
            />
          </Grid>
          <Grid size={{ xs: 12, sm: 6 }}>
            <TextField
              fullWidth
              label="Order Date"
              type="date"
              value={formData.order_date || ""}
              onChange={(e) => onFormDataChange({ ...formData, order_date: e.target.value })}
              InputLabelProps={{ shrink: true }}
              margin="dense"
              size="small"
              required
            />
          </Grid>
          <Grid size={{ xs: 12, sm: 6 }}>
            <TextField
              fullWidth
              label="Product Name"
              value={formData.product_name || ""}
              onChange={(e) => onFormDataChange({ ...formData, product_name: e.target.value })}
              margin="dense"
              size="small"
              required
            />
          </Grid>
          <Grid size={{ xs: 12, sm: 6 }}>
            <FormControl fullWidth margin="dense" size="small">
              <InputLabel>Status</InputLabel>
              <Select
                value={formData.status || "Pending"}
                onChange={(e) => onFormDataChange({ ...formData, status: e.target.value })}
                label="Status"
              >
                <MenuItem value="Pending">Pending</MenuItem>
                <MenuItem value="Active">Active</MenuItem>
                <MenuItem value="Completed">Completed</MenuItem>
                <MenuItem value="Cancelled">Cancelled</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid size={{ xs: 12, sm: 6 }}>
            <TextField
              fullWidth
              label="Amount"
              type="number"
              value={formData.amount || ""}
              onChange={(e) => onFormDataChange({ ...formData, amount: e.target.value })}
              margin="dense"
              size="small"
              required
              inputProps={{ step: "0.01", min: "0" }}
            />
          </Grid>
          <Grid size={{ xs: 12 }}>
            <TextField
              fullWidth
              label="Description"
              multiline
              rows={3}
              value={formData.description || ""}
              onChange={(e) => onFormDataChange({ ...formData, description: e.target.value })}
              margin="dense"
              size="small"
            />
          </Grid>
          <Grid size={{ xs: 12 }}>
            <TextField
              fullWidth
              label="Notes"
              multiline
              rows={2}
              value={formData.notes || ""}
              onChange={(e) => onFormDataChange({ ...formData, notes: e.target.value })}
              margin="dense"
              size="small"
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={onSave} variant="contained">
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
}
